module.exports = __webpack_public_path__ + "static/aarti-shah.351dcbd2.webp";